import React from 'react';
import { SectionCard } from '../../common/SectionCard';
import { EmptyState } from '../../common/EmptyState';
import { SeverityPill } from '../../common/StatusPills';
import { Progress } from '../../ui/Progress';
import { formatNumber } from '../../../utils/format';
import type { DeliveryDetail } from '../../../types/domain';
export function DeliverPanel({
  delivery
}: {
  delivery?: DeliveryDetail;
}) {
  if (!delivery) {
    return <EmptyState title="Not yet in live operations" description="Operating metrics, incident log, legacy benefits and closure reporting appear once the record clears the Readiness gate." data-id="element-642" data-mp="3khwnu3pey1sk" />;
  }
  const attendancePercent = Math.round(delivery.attendanceToday / delivery.attendanceTarget * 100);
  return <div className="space-y-4" data-id="element-643" data-mp="19pbmz38ej55l">
      <div className="grid gap-4 lg:grid-cols-4" data-id="element-644" data-mp="19oabwyrdyinv">
        <SectionCard title="Operating day" data-id="element-645" data-mp="19r69glzbn5bs">
          <p className="font-mono text-xl font-semibold" data-id="element-646" data-mp="14r1ux1hz4ko7">
            {delivery.operatingDay} / {delivery.operatingDays}
          </p>
          <div className="mt-2" data-id="element-647" data-mp="3a00hmnjsy5uv">
            <Progress value={delivery.operatingDay / delivery.operatingDays * 100} data-id="element-648" data-mp="3ezd4h8aobcxg" />
          </div>
        </SectionCard>
        <SectionCard title="Attendance today" data-id="element-649" data-mp="3jy6fmu2hmrug">
          <p className="font-mono text-xl font-semibold" data-id="element-650" data-mp="3jwbtjcfhctos">
            {formatNumber(delivery.attendanceToday)}
          </p>
          <p className="mt-1 text-[12px] text-muted-foreground" data-id="element-651" data-mp="2r9r0m7jcw9j4">
            {attendancePercent}% of {formatNumber(delivery.attendanceTarget)} target
          </p>
        </SectionCard>
        <SectionCard title="Service level" data-id="element-652" data-mp="2w6hh2vz2p752">
          <p className="font-mono text-xl font-semibold" data-id="element-653" data-mp="309e6p6n163ii">{delivery.serviceLevel}%</p>
          <p className="mt-1 text-[12px] text-muted-foreground" data-id="element-654" data-mp="351p8kf1bzzdp">
            {delivery.serviceLevel >= 90 ? 'Within the 90% operating threshold' : 'Below the 90% operating threshold'}
          </p>
        </SectionCard>
        <SectionCard title="Closure report" data-id="element-655" data-mp="2cj1rdapgh4hw">
          <p className="text-xl font-semibold" data-id="element-656" data-mp="3fv8rd8g8f27m">
            {delivery.closureReportIssued ? 'Issued' : 'Outstanding'}
          </p>
          <p className="mt-1 text-[12px] text-muted-foreground" data-id="element-657" data-mp="3avw7mwknqb99">
            Required to close the lifecycle
          </p>
        </SectionCard>
      </div>

      <div className="grid gap-4 xl:grid-cols-2" data-id="element-658" data-mp="3kmqspxm634t4">
        <SectionCard title="Incident log" bodyClassName="p-0" data-id="element-659" data-mp="3kn0ltu2ids31">
          <ul className="divide-y divide-border" data-id="element-660" data-mp="2wwefc785kfv5">
            {delivery.incidents.map(incident => <li key={incident.id} className="flex items-start justify-between gap-3 px-4 py-2.5" data-id="element-661" data-mp="2rymn1c3lirqf">
                <div className="min-w-0" data-id="element-662" data-mp="35vhux1842d4w">
                  <p className="text-[13px] leading-snug" data-id="element-663" data-mp="31vhifm4koc0h">{incident.label}</p>
                  <p className="mt-0.5 text-[11px] capitalize text-muted-foreground" data-id="element-664" data-mp="l7dckjda8kcp">
                    {incident.status}
                  </p>
                </div>
                <SeverityPill severity={incident.severity} data-id="element-665" data-mp="h5if5pyh2r47" />
              </li>)}
          </ul>
        </SectionCard>

        <SectionCard title="Legacy benefits" description="Captured against the pre-event baseline" bodyClassName="p-0" data-id="element-666" data-mp="toe25tqpy82l">
          <ul className="divide-y divide-border" data-id="element-667" data-mp="esoc9kiexasl">
            {delivery.legacyBenefits.map(benefit => <li key={benefit.id} className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-668" data-mp="jqgcd1t7o37v">
                <p className="text-[13px]" data-id="element-669" data-mp="17gke13mu9sw8">{benefit.label}</p>
                <span className="shrink-0 font-mono text-[12px] text-muted-foreground" data-id="element-670" data-mp="1cdu2afyhryih">
                  {benefit.value}
                </span>
              </li>)}
          </ul>
        </SectionCard>
      </div>
    </div>;
}